<template>
  <v-card class="mt-2" elevation="0">
    <v-card-title class="pt-1 headline font-weight-regular">
      Certifications and licenses
    </v-card-title>
    <highlight-change v-if="isNewSection" :delta-value="deltaSection"></highlight-change>
    <v-card-text>
      <v-list>
        <v-list-item v-for="(certificate, key) in certifications" :key="key" class="py-0 mb-2">
          <v-list-item-avatar tile class="grey" size="40" style="align-self: end">
            <v-icon>mdi-license</v-icon>
          </v-list-item-avatar>
          <v-list-item-content class="py-0 mb-2">
            <h3 class="title font-weight-medium text-truncate">{{certificate.title}}</h3>
            <h4 class="subtitle-2 font-weight-medium">
              <span>{{certificate.company.name}}</span>
            </h4>
            <h5 class="subtitle-2 grey--text" v-if="certificate.from">
              <span>Expedition: {{certificate.from}}</span>
            </h5>
            <h5 class="subtitle-2 grey--text" v-if="certificate.credentialId">
              <span>CredentialID: {{certificate.credentialId}}</span>
            </h5>
            <highlight-change v-if="deltaSection && !isNewSection" :delta-value="deltaSection[key]"></highlight-change>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>


<script>
  import ShowMoreLess from "../../Widgets/showMoreLess";
  import HighlightChange from "../../Widgets/highlightChange";

  export default {
    name: "certificationsMocker",
    components: {HighlightChange, ShowMoreLess},
    props: ['deltaSection', 'certifications'],
    computed: {
      isNewSection(){
        return this.deltaSection && (this.deltaSection[0] === false || this.deltaSection[1] === false);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mockers/Lin/certificationsMocker.vue